import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import SelectorItem from './item';
import { Text } from '../text';
import { is } from '../../services/classify';
import { getAlignClassName } from '../../objects';
/**
 * Selector Component
 * @param children {ReactNode} Children for Selector
 * @param onClick onClick event
 * @param activeIndex {number} default active tab index
 * @param disabled {boolean} Disabled Selector
 * @param clipped {boolean} Remove the separator bar
 * @param align {Alignable} Horizontal Align
 * - -------------------------- WEB PROPERTIES -------------------------------
 * @param className {string} Additionnal CSS Classes
 * @param fullwidth {boolean} Fullwidth Selector
 */
const Selector = ({ children, className, onClick, activeIndex, disabled, align, justify, ...others }) => {
    const [activateIndex, setActivateIndex] = useState(activeIndex || 0);
    const classes = clsx('selector', align && is(getAlignClassName(align)), justify && is(justify), className);
    const isActive = (index, childPropsActive) => {
        if (typeof childPropsActive !== 'undefined' && !activateIndex) {
            return childPropsActive;
        }
        if (index === activateIndex) {
            return true;
        }
    };
    const toggleActive = (e, index) => {
        if (disabled) {
            return false;
        }
        setActivateIndex(index);
        if (onClick) {
            onClick(e);
        }
    };
    useEffect(() => {
        setActivateIndex(activateIndex);
    }, [activateIndex]);
    return (React.createElement("div", { className: classes, role: 'tablist', ...others },
        React.createElement("ul", null, children &&
            Array.isArray(children) &&
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            children.map((child, index) => {
                const props = {
                    active: Boolean(isActive(index, child.props.active)) || false,
                    key: index,
                    tabIndex: index,
                    onClick: (event) => {
                        toggleActive(event, index);
                        if (child) {
                            if (child.props.onClick) {
                                child.props.onClick(event);
                            }
                        }
                    },
                };
                return typeof child.valueOf() === 'string' ? (React.createElement(SelectorItem, { active: props.active, onClick: (e) => onClick === null || onClick === void 0 ? void 0 : onClick(e) },
                    React.createElement(Text, null, String(child)))) : (React.cloneElement(child, props));
            }))));
};
export default Selector;
//# sourceMappingURL=Selector.js.map